<template>
    <b-modal 
        ref="logoutModal"
        :hide-footer="true"
    >
        <template v-slot:modal-header="{ close }">
            <a href="#">
                <img src="../../assets/images/logo-color.png" alt="Dicicil Aja">
            </a>
            <button @click="hide" type="button" class="close orange" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </template>

        <form role="form" class="p-lr-50">
            <h2 class="color-orange p-t-50 p-b-50 bold font-montserrat" v-if="isSuccess">Logout Berhasil</h2>
            <h2 class="color-orange p-t-50 p-b-50 bold font-montserrat" v-else>Logout Gagal</h2>
        </form>
    </b-modal>
</template>

<script>
export default {
    name: 'LogoutModal',
    props: {
        isSuccess: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        show () {
            this.$refs['logoutModal'].show()
        },
        hide () {
            this.$refs['logoutModal'].hide()
        }
    }
};
</script>
